var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    _vm._l(_vm.value, function(section, key) {
      return _c(
        "div",
        { key: section.id, staticClass: "mb-5" },
        [
          _c("div", { staticClass: "border-bottom pb-3" }, [
            _c(
              "div",
              { staticClass: "font-weight-bold d-flex align-items-center" },
              [
                _c(
                  "span",
                  {
                    staticClass:
                      "title-number-box rounded text-white text-center mr-2 py-1"
                  },
                  [_vm._v(" " + _vm._s(key + 1) + " ")]
                ),
                _c("span", [
                  _vm._v(" " + _vm._s(_vm._f("empty")(section.name)) + " ")
                ])
              ]
            )
          ]),
          _vm._l(section.questions, function(question, qKey) {
            return _c(
              "div",
              { key: question.id, staticClass: "border-bottom pb-3 my-3" },
              [
                _vm.isExpectativeQuestion(question)
                  ? _c("expectative", {
                      attrs: {
                        data: question,
                        "is-read-only": _vm.isReadOnly,
                        title: _vm.getExpectativeTitle(key, qKey)
                      },
                      model: {
                        value: question.value,
                        callback: function($$v) {
                          _vm.$set(question, "value", $$v)
                        },
                        expression: "question.value"
                      }
                    })
                  : _c("div", [
                      _vm._v("Tipo de pregunta no soportada actualmente")
                    ])
              ],
              1
            )
          })
        ],
        2
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }